import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-partner-program',
  imports: [],
  templateUrl: './partner-program.component.html',
  styleUrl: './partner-program.component.scss',
})
export class PartnerProgramComponent {
  protected readonly environment = environment;
}
